import logger from './logging/faro';

type RetryPromiseProps<T> = {
  fn: () => Promise<T>;
  retries?: number;
  delay?: number;
  delayMs?: (attempt: number) => number;
  shouldRetry?: (error: unknown) => boolean;
  label?: string;
};

const retryPromise = <T>({
  fn,
  retries = 3,
  delay = 1000,
  delayMs,
  shouldRetry,
  label,
}: RetryPromiseProps<T>): Promise<T> =>
  new Promise((resolve, reject) => {
    const attempt = (currentRetry = 0) => {
      fn()
        .then(resolve)
        .catch((err) => {
          if (currentRetry >= retries) return reject(err);
          if (shouldRetry && !shouldRetry(err)) return reject(err);

          const ms = delayMs ? delayMs(currentRetry) : delay;
          logger.warn(`Promise attempt failed, current attempt: ${currentRetry}, label: ${label}`, err);
          setTimeout(() => attempt(currentRetry + 1), ms);
        });
    };

    attempt();
  });

export default retryPromise;
